import useAuth from './useAuth';
import { UserRole, hasUserRole, hasAnyUserRole, getUserRoleLabel } from '@/lib/userRoles';

export const useUserRole = () => {
  const { user } = useAuth();

  const userRole = user?.user?.role as UserRole;

  return {
    userRole,
    
    // Getters
    getUserRoleLabel: () => getUserRoleLabel(userRole),
    
    // Verificadores de rol específico
    isMaster: () => hasUserRole(userRole, UserRole.MASTER),
    isProgrammer: () => hasUserRole(userRole, UserRole.PROGRAMMER),
    isSeller: () => hasUserRole(userRole, UserRole.SELLER),
    isPartner: () => hasUserRole(userRole, UserRole.PARTNER),
    
    // Verificadores de múltiples roles
    hasRole: (requiredRole: UserRole) => hasUserRole(userRole, requiredRole),
    hasAnyRole: (allowedRoles: UserRole[]) => hasAnyUserRole(userRole, allowedRoles),
    
    // Verificadores de permisos comunes
    canAccessAdmin: () => hasAnyUserRole(userRole, [UserRole.MASTER, UserRole.PROGRAMMER]),
    canAccessCompanies: () => hasAnyUserRole(userRole, [UserRole.MASTER, UserRole.PROGRAMMER, UserRole.PARTNER]),
    canAccessPartners: () => hasAnyUserRole(userRole, [UserRole.MASTER, UserRole.PROGRAMMER]),
    canAccessCRM: () => hasAnyUserRole(userRole, [UserRole.MASTER, UserRole.PROGRAMMER]),
    
    // Verificador genérico para componentes
    canAccess: (allowedRoles: UserRole[]) => {
      // Si el usuario no es de tipo 'user', permitir acceso (para Companies)
      if (user?.principalType !== 'user') {
        return true;
      }
      return hasAnyUserRole(userRole, allowedRoles);
    }
  };
};

export default useUserRole; 